import {parametersInfo, setSession, getSession} from '../../tools/config'
let exam = {
  state: {
    obj: {

    }
  },
  mutations: {
    setParameters (state, obj) {
      debugger;
      let o = state.obj || []
      for (let key in obj) {
        o[key] = obj[key]
      }
      setSession(parametersInfo, o)
      state.obj = o
    },
    resetParameters (state) {
      setSession(parametersInfo, {})
      state.obj = []
    }
  },
  getters: {
    getParameters (state) {
      if (!state.obj) {
        state.obj = getSession(parametersInfo) || {}
      }
      debugger;
      return state.obj
    }
  }
}

export default exam



// WEBPACK FOOTER //
// ./src/store/modules/parameters.js